// extracted by mini-css-extract-plugin
export default {"photocard":"PhotoCard_photocard__oBAvn"};